<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row mb-2">
          <div class="col-sm-5">
          </div>
          <div class="col-sm-7">
            <div class="float-sm-end d-flex">
            <button type="button" class="btn btn-sm btn-primary mb-2" @click="newCategory()">
              <i class="mdi mdi-plus mr-1"></i> Nova Categoria
            </button>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
      <div class="container-fluid custom-scroll">
        <div class="row row-item" v-if="categories.length === 0">
          <div class="col texts-box text-truncate">
            <div class="text-2 text-truncate text-center">Nenhuma categoria cadastrada</div>
          </div>
        </div>
        <div class="row row-item" v-for="(category, i) in categories" :key="i">
          <div class="col texts-box text-truncate link" @click="editCategory(category.id)">
            <div class="text-1 text-truncate">{{ category.name }}</div>
            <div class="text-2 text-truncate">{{ category.description }}</div>
          </div>
          <div class="col-auto">
            <div class="flex justify-end">
              <button type="button" @click="deleteCategory(category.id)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
      <modal-form v-model="modalForm" :idHotel=idHotel ref="formCategory" @created="updateList"></modal-form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ModalForm from './Form'
import Swal from 'sweetalert2'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    ModalForm
  },
  name: 'categoreis',
  props: {
    idHotel: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      search: '',
      filter: {
        status: 0
      },
      statusList: ['Todos os status', 'Ativo', 'Inativo'],
      statusLabel: ['', 'Inativo', 'Ativo'],
      modalForm: false,
      modalRoom: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      hotelId: null,
      idParticipant: null,
      submitted: false
    }
  },
  mounted () {
    this.updateList()
    this.loading = false
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('hotelCategory', ['categories'])
  },
  methods: {
    ...mapActions('hotelCategory', {
      getAll: 'getAll',
      destroyCategory: 'deleteCategory'
    }),
    showFilters () {
      this.$refs.modalFilter.open()
    },
    newCategory () {
      this.$refs.formCategory.open('')
      this.modalForm = true
    },
    editCategory (id) {
      this.$refs.formCategory.open(id)
      this.modalForm = true
      this.idCategory = id
    },
    openRooms (id) {
      this.$refs.formRoom.open(id)
      this.modalRoom = true
      this.hotelId = id
    },
    deleteCategory (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyCategory(id).then((res) => {
              successMessage('Sucesso: Categoria excluída com sucesso.', 2500)
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        hotel_id: this.idHotel || null
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { max-height: 300px;}
.float-sm-end { float: right }

.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.test-scroll {
  max-height: 300px;
  overflow-y: auto;
}
.custom-scroll{
  overflow-y: auto;
  max-height: 300px;
  padding-bottom: 0;
}
.fix-w {
  --width: 100px;
  --font-size: 13px;
  --icon-size: 16px;
  --btn-justify: space-evenly;
  --btn-padding: 0.20rem 0.08rem;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 100px;
    --font-size: 13px;
    --icon-size: 16px;
    --btn-justify: space-around;
    --btn-padding: 0.20rem 0.35rem;
  }

  width: var(--width);

  button {
    font-size: var(--font-size);
    display: flex;
    align-items: center;
    justify-content: var(--btn-justify);
    padding: var(--btn-padding);

    i {
      font-size: var(--icon-size);
    }
  }
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 5px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(217, 217, 217, 0.461);
  align-items: center;
  cursor: pointer;
}
.texts-box {
  .text-1 {
    font-size: 14px;
    color: #05162B;
  }

  .text-2 {
    font-size: 12px;
    color: #05162B87;
  }
}
</style>
